import merge from "lodash/merge";

export function deepMergeTokens<T extends object>(...tokens: object[]): T {
    return merge({}, ...tokens);
}

export function addStyles(css: string, shouldAdd: boolean): string {
    return shouldAdd ? css : "";
}
